import { BriefPanel as BriefPanelComponent } from './BriefPanel.component';
import { connector } from './BriefPanel.connector';

export const BriefPanel = connector(BriefPanelComponent);
